// binCardConstants.js
export const BinCard_MAXLINE_REQUEST = "BIN_CARD_MAXLINE_REQUEST";
export const BinCard_MAXLINE_SUCCESS = "BIN_CARD_MAXLINE_SUCCESS";
export const BinCard_MAXLINE_FAIL = "BIN_CARD_MAXLINE_FAIL";

export const BinCard_BYLINE_REQUEST = "BIN_CARD_BYLINE_REQUEST";
export const BinCard_BYLINE_SUCCESS = "BIN_CARD_BYLINE_SUCCESS";
export const BinCard_BYLINE_FAIL = "BIN_CARD_BYLINE_FAIL";

export const BinCard_TRANSACTION_REQUEST = "BIN_CARD_TRANSACTION_REQUEST";
export const BinCard_TRANSACTION_SUCCESS = "BIN_CARD_TRANSACTION_SUCCESS";
export const BinCard_TRANSACTION_FAIL = "BIN_CARD_TRANSACTION_FAIL";
